import { useShow } from "@refinedev/core";
import { Show } from "@refinedev/mui";
import { Stack, Typography, Alert } from "@mui/material";

import {
    DetailSection,
    FieldGrid,
    FieldItem,
    RelatedLink,
    joinParts,
} from "components/detail";

export const CallShow = () => {
    const { queryResult } = useShow();
    const { data, isLoading, isError } = queryResult;
    const record = data?.data;

    return (
        <Show
            isLoading={isLoading}
            title={
                <Typography variant="h5">
                    시설연락 상세{record?.id ? ` · ${record.id}` : ""}
                </Typography>
            }
        >
            {isError && (
                <Alert severity="error" sx={{ mb: 2 }}>
                    시설연락 정보를 불러오지 못했습니다.
                </Alert>
            )}

            <Stack spacing={2}>
                <DetailSection title="기본 정보">
                    <FieldGrid columns={2}>
                        {/* 원본 인라인 id 링크 유지: 경로 문자열 동일 */}
                        <FieldItem
                            label="시설ID"
                            value={
                                record?.centerId != null ? (
                                    <RelatedLink
                                        to={`/centers/show/${record.centerId}`}
                                        label={String(record.centerId)}
                                    />
                                ) : undefined
                            }
                        />
                        {/* 원본이 raw 값을 그대로 노출했으므로 매핑 없이 유지 */}
                        <FieldItem label="IN/OUT" value={record?.in_out} />
                        {/* 원본 record?.c_manager+" "+record?.m_email+" "+record?.m_ph 조합 → joinParts */}
                        <FieldItem
                            label="시설 관계자"
                            value={joinParts([
                                record?.c_manager,
                                record?.m_email,
                                record?.m_ph,
                            ])}
                        />
                        {/* 원본 record?.date+" "+record?.time 조합 → joinParts */}
                        <FieldItem
                            label="연락일"
                            value={joinParts([record?.date, record?.time])}
                        />
                        <FieldItem label="참여여부" value={record?.participation} />
                        <FieldItem
                            label="최초 연락 콜요원"
                            value={
                                record?.userId != null ? (
                                    <RelatedLink
                                        to={`/fisUsers/show/${record.userId}`}
                                        label={String(record.userId)}
                                    />
                                ) : undefined
                            }
                        />
                        <FieldItem
                            label="최종 수정 콜요원"
                            value={
                                record?.modifiedStaffId != null ? (
                                    <RelatedLink
                                        to={`/fisUsers/show/${record.modifiedStaffId}`}
                                        label={String(record.modifiedStaffId)}
                                    />
                                ) : undefined
                            }
                        />
                    </FieldGrid>
                </DetailSection>

                <DetailSection title="메모">
                    <FieldGrid columns={1}>
                        <FieldItem
                            label="시설관련 메모"
                            span={2}
                            multiline
                            value={record?.center_etc}
                        />
                        <FieldItem
                            label="현장요원관련 메모"
                            span={2}
                            multiline
                            value={record?.agent_etc}
                        />
                    </FieldGrid>
                </DetailSection>

                <DetailSection title="메타 정보">
                    <FieldGrid columns={2}>
                        <FieldItem label="생성일" value={record?.createdAt} />
                        <FieldItem label="수정일" value={record?.updatedAt} />
                    </FieldGrid>
                </DetailSection>
            </Stack>
        </Show>
    );
};
